import BigNumber from './layout/bigNumber';
import Fact from './layout/fact';
import Wrapper from './layout/wrapper';
import React from 'react';

const formatNumber = value => Number(value || 0).toLocaleString('es-ES', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const FuelDemand = ({ kpiDict, año }) => {
  const targetYear = kpiDict.demanda_energia_combustible_target_year || año;
  const topEnergySources = kpiDict.demanda_energia_combustible_top_energeticos || [];

  return (
    <Wrapper>
      <Fact>
        <h4>
          Los 3 energéticos con mayor demanda de energía en {targetYear} son:
        </h4>
        <BigNumber>
          {topEnergySources.length > 0 ? (
            topEnergySources.map((source, index) => (
              <h4 key={source.label}>
                {index + 1}. {source.label}: {formatNumber(source.value)} TCal
              </h4>
            ))
          ) : (
            <h4>No hay datos disponibles para calcular el ranking.</h4>
          )}
        </BigNumber>
      </Fact>
    </Wrapper>
  );
};

export default FuelDemand;
